import { HttpLink } from "@apollo/client";
import { environment } from "../../config";

export const httpLink = new HttpLink({
  uri: `${environment.api.url}/graphql`,
});
